export type ServiceType = {
  service_type?: string;
  display_name: string;
  service_category?: string;
  service_access: string;
  service_domain: string;
  service_icon?: string;
  account_url?: string;
};

export const LegacyProducts = {
  ASSETS: 'assets',
  COST_MANAGEMENT: 'costManagement',
  FIELD_MANAGEMENT: 'fieldManagement',
  PRODUCT_MANAGEMENT: 'projectManagement',
  DOCUMENT_MANAGEMENT: 'documentManagement',
  QUANTIFICATION: 'quantification',
  FIELD: 'field',
  GLUE: 'glue',
  PLAN: 'plan',
};
